export const createIdeaEvaluations = (value) => (dispatch, getState, { api }) => {
  return api.post(`/private/ideaEvaluation/create`, value);
}
